import React, {FC} from 'react';
import {View} from 'react-native';

import Text, {TextProps} from '@/components/Text';
import {useThemedStyles} from '@/theme';

import {styles} from './TextDivider.style';

interface IProps {
  text: TextProps;
}

const TextDivider: FC<IProps> = ({text}) => {
  const style = useThemedStyles(styles);

  return (
    <View style={style.container}>
      <View style={style.divider} />
      <Text size="xs" {...text} />
      <View style={style.divider} />
    </View>
  );
};

export default TextDivider;
